module.exports = __webpack_public_path__ + "static/media/work.7dcffc9f.png";